import axios from "axios";
import { makeArray } from "../../permissionUtils";
//https://developers.arcgis.com/rest/geocode/api-reference/geocoding-find-address-candidates.htm
const ArcGISWorldGeocoderURL =
    "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer";
const ArcGISReverseGeocoder = (geocoderConfig, mapConfig, coordinate, callback) => {
    const location = {
        x: coordinate[0],
        y: coordinate[1],
        spatialReference: { wkid: mapConfig.projection.split(":")[1] },
    };

    if (geocoderConfig) {
        try {
            axios
                .get(
                    `${
                        geocoderConfig.ConnectionString
                    }/reverseGeocode?f=json&featuretypes=PointAddress&distance=1000&location=${encodeURIComponent(
                        JSON.stringify(location)
                    )}`,
                    {
                        headers: {},
                    }
                )
                .then((resp) => {
                    if (resp.data.address) {
                        callback(resp.data.address.Match_addr);
                    } else {
                    }
                });
        } catch (error) {}
    } else {
        //Default to use the ESRI World Geocoder
        try {
            axios
                .get(
                    `${ArcGISWorldGeocoderURL}/reverseGeocode?f=json&featuretypes=PointAddress&distance=1000&location=${encodeURIComponent(
                        JSON.stringify(location)
                    )}`,
                    {
                        headers: {},
                    }
                )
                .then((resp) => {
                    if (resp.data.address) {
                        callback(resp.data.address.Match_addr);
                    } else {
                    }
                });
        } catch (error) {}
    }
};

export const findAddress = (mapconfig, coordinate, callback) => {
    let mapData = mapconfig.map;
    if (!coordinate || coordinate.length < 0) {
        return;
    }
    if (!mapconfig.GeocodingEndpoints) {
        //Default no geocoder in config
        ArcGISReverseGeocoder(null, mapData, coordinate, callback);
    }

    let geocoders = makeArray(mapconfig.GeocodingEndpoints.GeocodingEndpoint);

    if (geocoders) {
        geocoders.forEach((element) => {
            if (element.IsDefaultReverseGeocoder) {
                if (element.Type.toLowerCase() === "ArcGISGeocoder".toLowerCase()) {
                    ArcGISReverseGeocoder(element, mapData, coordinate, callback);
                } else if (
                    element.Type.toLowerCase() === "GoogleGeocoder".toLowerCase()
                ) {
                } else if (element.Type.toLowerCase() === "BingGeocoder".toLowerCase()) {
                }
            }
        });
    }
};
